import { render, staticRenderFns } from "./merchandiseList.vue?vue&type=template&id=5d280d89&scoped=true&"
import script from "./merchandiseList.vue?vue&type=script&lang=js&"
export * from "./merchandiseList.vue?vue&type=script&lang=js&"
import style0 from "./merchandiseList.vue?vue&type=style&index=0&id=5d280d89&scoped=true&lang=css&"
import style1 from "./merchandiseList.vue?vue&type=style&index=1&id=5d280d89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d280d89",
  null
  
)

export default component.exports